import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import bigCoins from './images/金币大.png'
import bigCard from './images/免费卡.png'
import bigHead from './images/头框.png'

export const rewardList = [bigCard, bigCoins, bigHead]

// 男用户激励任务页 (http://wiki.xunlei.cn/pages/viewpage.action?pageId=145480754)
export const maleReward = createAsyncThunk(
  '/live/hiya_socialize/fetch_male_reward_page',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/fetch_male_reward_page',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

// 每日签到 http://wiki.xunlei.cn/pages/viewpage.action?pageId=145480801
export const signIn = createAsyncThunk(
  '/live/hiya_socialize/male_reward_page_signin',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/hiya_socialize/male_reward_page_signin',
      {
        ...store.getState().env.deviceinfo,
        ...p,
      }
    )
    return resp.data
  }
)

export enum rewardType {
  聊天卡片 = 1,
  金币 = 2,
  聊天气泡 = 3,
}

export interface sign_reward {
  signin_day: number
  reward_type: rewardType
  reward_cnt: number
}

export interface taskItem {
  task_id: number
  task_name: string
  jump_url: string
  task_icon: string // 任务icon
  reward_icon: string // 奖励图标
  reward_type: rewardType
  reward_cnt: number
  task_need_cnt: number // 任务目标次数
  subtask_need_cnt: number // 任务目标次数
  task_cur_cnt: number // 任务累计次数
  subtask_cur_cnt: number // 任务累计次数
  task_complete_cnt: number // 任务完成次数
}

export interface InitialStateType {
  mid?: number
  free_card_cnt?: number // 剩余卡片数量
  signin_cnt?: number // 签到次数
  today_signin?: boolean // 判断今日是否签到
  signin_rewards?: Array<sign_reward> // 签到奖励
  daily_tasks?: Array<taskItem>
  novice_tasks?: Array<taskItem>
}

const initialState: InitialStateType = {
  mid: 0,
  free_card_cnt: 0,
  signin_cnt: 0,
  today_signin: false,
  signin_rewards: [],
  daily_tasks: [],
}
export const ManPowerSlice = createSlice({
  name: 'ManPower',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(maleReward.fulfilled, (state, action) => {
      Object.assign(state, action.payload.data)
    })
  },
})

export default ManPowerSlice.reducer
